// Phase T2.0A Prompt 1 — Event registration API client (tournaments + RRs)
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

function api() {
  const token = localStorage.getItem('tl_session_token');
  return axios.create({
    baseURL: `${BASE}/api`,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export const registrationAPI = {
  // ---- Tournaments ----
  tournamentRegister: (tid, body) => api().post(`/tournaments/${tid}/register`, body),
  tournamentUnregister: (tid)     => api().delete(`/tournaments/${tid}/register`),
  tournamentEligiblePartners: (tid) => api().get(`/tournaments/${tid}/eligible-partners`),
  tournamentValidateEntries: (tid)  => api().get(`/tournaments/${tid}/validate-entries`),

  // ---- Round Robins ----
  rrRegister: (rrId, body) => api().post(`/round-robins/${rrId}/register`, body),
  rrUnregister: (rrId)     => api().delete(`/round-robins/${rrId}/register`),
  rrEligiblePartners: (rrId) => api().get(`/round-robins/${rrId}/eligible-partners`),
  rrValidateEntries: (rrId)  => api().get(`/round-robins/${rrId}/validate-entries`),
};
